import {common_utils} from "../common/common_utils";
import {slots_tool} from "./slots_tool";

function game_5005()
{

}

game_5005.odd_map  = {
  "S":[0,0,20,20,20],
  "W":[0,0,0,0,1000],
  "P4":[0,10,50,200,1000],
  "P3":[0,5,30,100,500],
  "P2":[0,5,20,80,300],
  "P1":[0,5,20,80,300],
  "A":[0,0,5,30,150],
  "K":[0,0,5,30,150],
  "Q":[0,0,5,20,100],
  "J":[0,0,5,20,100],
  "T":[0,0,5,20,100],
};

game_5005.mul = 10

game_5005.readHitValue = function(hits){
  var winListDic = {}
  for (let i = 0; i < hits.length; i++) {
    let win_data = hits[i];
    slots_tool.read_win_data(winListDic,win_data)
  }
  return winListDic;
}



game_5005.readDataValue = function(this1,data){
  this1.hasextra = true
  this1.hasfree = true
  this1.hasbonuswin = false
  this1.mapList = []

  var rows = 3
  this1.isfree = common_utils.isFreeTip(data)
  var mapJson = JSON.parse(data.detail.mapData)
  this1.scatterwin = mapJson.Data.ScatterWin
  this1.extra = mapJson.IsExtraBet
  this1.symbol1 = mapJson.SpecialSymbol1
  if(this1.extra) {
    this1.symbol2 = mapJson.SpecialSymbol2
  }
  common_utils.readDataValue(this1,data);
  // this1.mapListDetail = [];
  for (var j = 0; j < rows; j++) {
    for (var i = 0; i < 5; i++) {
      var wild = mapJson.Data.Map[i].filter((item) =>
      {
        return item == "W"
      })
      if (wild.length > 0) {
        this1.mapList.push("W")
      } else {
        this1.mapList.push(mapJson.Data.Map[i][j])
      }
    }
    // slots_tool.read_win_data(this1.mapListDetail,win_data)
  }

  this1.mapIndex = []
  this1.mapListDetail = {};
  for (var index = 0; index < mapJson.Data.Wins.length; index++)
  {
    var line = true;
    let win_data = mapJson.Data.Wins[index];
    for(var subIndex = 0; subIndex < 5; subIndex++) {
      var showindex = win_data.l[subIndex] * 5 + subIndex;
      var item = this1.mapList[showindex];
      if ((item != win_data.s) && (item != "W"))
      {
        line = false
      }
      if (line) {
        this1.mapIndex.push(showindex)
      }

    }
    slots_tool.read_win_data(this1.mapListDetail,win_data)
  }

  let winValueList = [];
  slots_tool.setWinValue(winValueList,this1.mapListDetail,game_5005.odd_map,0);
  this1.subMapIndex = []
  this1.subMapListDetail = []

  if (this1.symbol1)
  {
    var hits = []
    if (mapJson.Data.ExWins)
    {
      hits = mapJson.Data.ExWins.filter((item) => {
        return item.s == this1.symbol1
      })
    }
    if (hits.length > 0) {
      var subMap = []
      var subIndexNew = []
      for (var j = 0; j < rows; j++)
      {
        for (var i = 0; i < 5; i++)
        {
          var hitsSub = mapJson.Data.Map[i].filter((item) =>
          {
            return item == this1.symbol1
          })
          if (hitsSub.length > 0) {
            subMap.push(this1.symbol1)
            subIndexNew.push(j * 5 + i)
          } else {
            subMap.push(mapJson.Data.Map[i][j])
          }
        }

      }
      this1.subMapList.push(subMap)
      this1.subMapIndex.push(subIndexNew)
      this1.subMapListDetail.push(game_5005.readHitValue(hits))
    }
  }

  if (this1.symbol2)
  {
    var hits = []
    if (mapJson.Data.ExWins)
    {
      hits = mapJson.Data.ExWins.filter((item) =>
      {
        return item.s == this1.symbol2
      })
    }
    if (hits.length > 0) {
      var subMap = []
      var subIndexNew = []
      for (var j = 0; j < rows; j++) {
        for (var i = 0; i < 5; i++) {
          var hitsSub = mapJson.Data.Map[i].filter((item) => {
            return item == this1.symbol2
          })
          if (hitsSub.length > 0) {
            subMap.push(this1.symbol2)
            subIndexNew.push(j * 5 + i)
          } else {
            subMap.push(mapJson.Data.Map[i][j])
          }
        }
      }
      this1.subMapList.push(subMap)
      this1.subMapIndex.push(subIndexNew)
      this1.subMapListDetail.push(game_5005.readHitValue(hits))
    }
  }
  slots_tool.setWinValue(winValueList,this1.subMapListDetail,game_5005.odd_map,0);
  this1.winValueTotal = slots_tool.TotalValueByData(winValueList,data,game_5005.mul,mapJson.IsExtraBet)
  this1.$nextTick(() => {
    this1.$nextTick(() => {
      this1.$nextTick(() => {
        this1.clearLines();
        setTimeout(() => {
          this1.clearLines();
          for (let index = 0; index < mapJson.Data.Wins.length; index++)
          {
            let wins = mapJson.Data.Wins[index];
            for(let subIndex = 0; subIndex < 4; subIndex++)
            {
              let fromIndex = wins.l[subIndex] * 5 + subIndex;
              let toIndex = wins.l[subIndex + 1] * 5 + subIndex + 1;
              slots_tool.drawLines(slots_tool.setLineIdName(0,fromIndex), slots_tool.setLineIdName(0,toIndex), index)
            }
          }

          var s = 0;
          if (this1.symbol1)
          {
            var hits = []
            if (mapJson.Data.ExWins)
            {
              hits = mapJson.Data.ExWins.filter((item) =>
              {
                return item.s == this1.symbol1
              })
            }
            if (hits.length > 0)
            {
              for (let index = 0; index < hits.length; index++)
              {
                for(let subIndex = 0; subIndex < 4; subIndex++)
                {
                  let fromIndex = hits[index].l[subIndex] * 5 + subIndex;
                  let toIndex = hits[index].l[subIndex + 1] * 5 + subIndex + 1;
                  slots_tool.drawLines(slots_tool.setMapsLineIdName("s",s,fromIndex), slots_tool.setMapsLineIdName("s",s,toIndex), index)
                }
              }
              s++
            }
          }

          if (this1.symbol2)
          {
            var hits = []
            if (mapJson.Data.ExWins)
            {
              hits = mapJson.Data.ExWins.filter((item) =>
              {
                return item.s == this1.symbol2
              })
            }
            if (hits.length > 0)
            {
              for (let index = 0; index < hits.length; index++)
              {
                for(let subIndex = 0; subIndex < 4; subIndex++)
                {
                  let fromIndex = hits[index].l[subIndex] * 5 + subIndex;
                  let toIndex = hits[index].l[subIndex + 1] * 5 + subIndex + 1;
                  slots_tool.drawLines(slots_tool.setMapsLineIdName("s",s,fromIndex), slots_tool.setMapsLineIdName("s",s,toIndex), index)
                }
              }
            }
          }
        }, 1000);

      })
    })
  })
}


export {
  game_5005
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5005.js